"use client";

import Link from 'next/link';
import Image from 'next/image';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

interface BlogCardProps {
  slug: string;
  title: string;
  date: string;
  image?: string;
  description?: string;
  summary?: string;
}

export function BlogCard({ 
  slug, 
  title, 
  date, 
  image, 
  description, 
  summary 
}: BlogCardProps) {
  return (
    <div className="relative group cursor-pointer">
      {/* Full-card clickable overlay */}
      <Link 
        href={`/blog/${slug}`} 
        className="absolute inset-0 z-10" 
        aria-label={`Read blog post: ${title}`}
      >
        <span className="sr-only">Read blog post: {title}</span>
      </Link>
      
      <Card className="h-full overflow-hidden shadow-md group-hover:shadow-xl transition-all duration-300 flex flex-col">
        {image && (
          <div className="relative h-48 w-full overflow-hidden">
            <Image
              src={image}
              alt={title || `Blog post: ${slug}`}
              fill
              className="object-cover object-center group-hover:scale-105 transition-transform duration-300 blog-card-image"
              sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
            />
          </div>
        )}
        <CardHeader className="flex-grow">
          <CardTitle className="text-xl font-semibold group-hover:text-primary transition-colors">
            {title}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground mb-3 line-clamp-3">
            {description || summary}
          </p>
          <p className="text-xs text-muted-foreground">
            {new Date(date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
